import React from 'react';
import { ModalHeader, ModalBody } from 'reactstrap';

function ModalLoading({ onClose = () => {} }) {
  return (
    <>
      <ModalHeader toggle={onClose}>'Choose an assessment'</ModalHeader>

      <ModalBody>
        <p>Loading available questions…</p>
      </ModalBody>
    </>
  );
}

export default ModalLoading;
